import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from './bootstrap/Modal';
import FormGroup from '../component/FormGroup/FormGroup';
import { FormActions } from '../component/FormActions/FormActions';

var AppStore = require('../store/appStore');
var AppAction = require('../action/appAction');
var ActionType = require('../constants/actionType');
var textHelpers = require('./text-helpers');
import FormGroupInnerInlineLabel from './formGroupInnerInlineLabel';
import { Row } from '../component/Row/Row';

exports.FormGroupInlineLabel = FormGroupInnerInlineLabel;
/** @deprecated */
exports.Row = Row;
exports.PanelGroup = (props) => (
  <div {...props} className={(props.className || "") + " panel-group"}/>);
exports.Panel = (props) => (<div {...props}
  className={(props.className || "") + " panel panel-default"}/>);
exports.PanelHeading = (props) => (
  <div {...props} className={(props.className || "") + " panel-heading"}/>);
exports.PanelAction = (props) => (
  <div {...props} className={(props.className || "") + " panel-action"}/>);
exports.PanelCollapse = (props) => (
  <div {...props} className={(props.className || "") + " panel-collapse"}/>);
exports.PanelTop = (props) => (
  <div {...props} className={(props.className || "") + " panel-top"}/>);
exports.PanelBody = (props) => (
  <div {...props} className={(props.className || "") + " panel-body"}/>);


/**
 * Popover window. Use "AppAction.setPopover" method for display this item
 */
exports.Popover = React.createClass({

  POPOVER_REF: 'Popover',

  propTypes: {
    title: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.element
    ]),
    width: React.PropTypes.number,
    deltaY: React.PropTypes.number
  },

  getDefaultProps(){
    return {
      width: 200,
      deltaY: 5
    };
  },

  getInitialState(){
    return {isOpened: false};
  },

  componentDidMount: function () {
    AppStore.addChangeListener(this.onOpenPopover);
  },

  componentWillUnmount: function () {
    AppStore.removeChangeListener(this.onOpenPopover);
  },

  onOpenPopover(){
    /*TODO: remove this object*/
  },

  render(){

    var className = (this.props.className || "") + " popover";


    var style = this._getPopoverStyle();

    return (
      <div className={className} ref={this.POPOVER_REF} style={style}>
        {this._getContent()}
      </div>
    )
  },

  _getPopoverStyle(){
    var currentNode = this.refs[this.POPOVER_REF];
    if (!currentNode || !this.state.isOpened)
      return {
        display: "none"
      };

    var self = this,
      parentNode = currentNode.parentNode,
      relativeParent = textHelpers.getFirstRelativeParent(currentNode),
      parentRect = parentNode.getBoundingClientRect(),
      relativeParentRect = relativeParent ? relativeParent.getBoundingClientRect() : {
        top: 0,
        left: 0
      };

    return {
      position: 'absolute',
      top: parentRect.top - relativeParentRect.top + parentRect.height + self.props.deltaY,
      left: parentRect.left - relativeParentRect.left + (parentRect.width - self.props.width) / 2,
      width: self.props.width + 'px'
    }
  },

  _getContent(){
    if (!this.state.isOpened) return null;

    return [
      <div key='arrow' className="arrow" style={{left: 50 + "%"}}></div>,
      <h3 key='title' className="popover-title">{this.props.title}</h3>,
      this.props.children ? <div key='content'
                                 className="popover-content">{this.props.children}</div> : null
    ];
  }
});

/*<editor-fold desc="[Modal dialog]">*/
// @deprecated
exports.Modal = Modal;

// @deprecated
exports.ModalHeader = ModalHeader;

// @deprecated
exports.ModalBody = ModalBody;

// @deprecated
exports.ModalFooter = ModalFooter;
/*</editor-fold desc="[Modal dialog]">*/

/*<editor-fold desc="[Forms]">*/
// @deprecated
exports.FormGroup = FormGroup;


/**
 * BS button group
 */
exports.ButtonGroup = React.createClass({
  render: function () {
    return (
      <div className="btn-group" data-toggle="buttons"
      >
        {this.props.children}
      </div>
    );
  }
});


// @deprecated
exports.FormActions = FormActions;

/**
 *  Bs Form group for account
 * @prop {string} elementId depended field id for label
 * @prop {string|ReactElement} label field label
 */
exports.FormGroupAccount = React.createClass({

  propTypes: {
    type: React.PropTypes.string
  },

  render: function () {

    var content = this.props.type == "checkbox"
      ? this._getCheckboxFieldContent()
      : this._getInputFieldContent();

    return (
      <section>
        {content}
      </section>
    );
  },

  _getInputFieldContent(){
    return [
      this._getLabel(),
      <label key="field" className="input">
        {this.props.children}
      </label>
    ];
  },

  _getCheckboxFieldContent(){
    return (
      <label className="checkbox">
        {this.props.children}
        {this.props.label}
      </label>
    )
  },

  _getLabel: function () {
    return this.props.label
      ? (<label key="label" className="label" htmlFor={this.props.elementId}>
      {this.props.label}
    </label>)
      : null;
  }
});

/**
 * BS Form actions container for account
 */
exports.FormActionsAccount = React.createClass({
  render: function () {
    return (
      <footer>
        {this.props.children}
      </footer>
    );
  }
});


exports.FormControlError = (props) => (
  <label className="error">{props.children}</label>);
/*</editor-fold desc="[Forms]">*/
